/**
 * Cart Variant Selector - Custom Dropdown
 * Changes variant based on "Тип шкіри" option
 */
(function() {
  'use strict';
  
  if (window.CartVariantSelectorInitialized) return;
  window.CartVariantSelectorInitialized = true;

  console.log('🛒 Cart Variant Selector: Script loaded');

  // Close all dropdowns
  function closeAllDropdowns() {
    document.querySelectorAll('.cart-item__variant-selector.is-open').forEach(el => {
      el.classList.remove('is-open');
      const trigger = el.querySelector('[data-dropdown-trigger]');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    });
  }

  // Toggle dropdown
  function toggleDropdown(selector) {
    const isOpen = selector.classList.contains('is-open');
    closeAllDropdowns();
    
    if (!isOpen) {
      selector.classList.add('is-open');
      const trigger = selector.querySelector('[data-dropdown-trigger]');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
    }
  }

  // Get variant data
  function getVariantData(line) {
    const script = document.querySelector(`.cart-item-variant-data[data-line="${line}"]`);
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      console.error('🛒 Error parsing variant data:', e);
      return null;
    }
  }

  // Find matching variant
  function findMatchingVariant(data, newSkinValue) {
    const { skinTypeIndex, currentOptions, variants } = data;
    
    for (const variant of variants) {
      if (variant.options[skinTypeIndex] !== newSkinValue) continue;
      
      let allMatch = true;
      for (let i = 0; i < currentOptions.length; i++) {
        if (i === skinTypeIndex) continue;
        if (variant.options[i] !== currentOptions[i]) {
          allMatch = false;
          break;
        }
      }
      
      if (allMatch) return variant;
    }
    return null;
  }

  // Change variant
  async function changeVariant(selector, newSkinValue) {
    const line = selector.dataset.line;
    const errorEl = selector.querySelector('[data-variant-error]');
    const triggerText = selector.querySelector('[data-selected-value]');
    
    const data = getVariantData(line);
    if (!data) {
      console.error('🛒 No variant data found for line:', line);
      return;
    }

    console.log('🛒 Changing skin type to:', newSkinValue);
    
    const matchingVariant = findMatchingVariant(data, newSkinValue);
    if (!matchingVariant) {
      console.error('🛒 No matching variant found');
      if (errorEl) {
        errorEl.textContent = 'Варіант недоступний';
        errorEl.classList.add('is-visible');
      }
      return;
    }

    if (!matchingVariant.available) {
      console.log('🛒 Variant not available');
      if (errorEl) {
        errorEl.textContent = 'Немає в наявності';
        errorEl.classList.add('is-visible');
      }
      return;
    }

    console.log('🛒 Found matching variant:', matchingVariant.id);
    
    // Get quantity
    const quantityInput = document.querySelector(`input[data-index="${line}"]`);
    const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;

    // Show loading
    selector.classList.add('is-loading');
    selector.classList.remove('is-open');
    if (errorEl) errorEl.classList.remove('is-visible');

    try {
      // Remove old item
      console.log('🛒 Removing old item:', data.itemKey);
      const removeResponse = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: data.itemKey, quantity: 0 })
      });
      
      if (!removeResponse.ok) throw new Error('Failed to remove item');
      
      // Add new variant
      console.log('🛒 Adding new variant:', matchingVariant.id, 'qty:', quantity);
      const addResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: matchingVariant.id, quantity: quantity })
      });
      
      if (!addResponse.ok) throw new Error('Failed to add item');
      
      console.log('🛒 Variant changed successfully');
      
      // Refresh cart
      refreshCart();
      
    } catch (error) {
      console.error('🛒 Error changing variant:', error);
      selector.classList.remove('is-loading');
      if (errorEl) {
        errorEl.textContent = 'Помилка. Спробуйте ще раз.';
        errorEl.classList.add('is-visible');
      }
    }
  }

  // Refresh cart
  function refreshCart() {
    document.dispatchEvent(new CustomEvent('cart-drawer:refresh'));
    
    if (typeof window.PUB_SUB_EVENTS !== 'undefined') {
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      if (typeof publish === 'function') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-variant-selector' });
      }
    }
    
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.refresh === 'function') {
      cartDrawer.refresh();
    }
    
    fetch('/cart?section_id=cart-drawer')
      .then(r => r.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newContent = doc.querySelector('.drawer__inner');
        const currentContent = document.querySelector('.drawer__inner');
        if (newContent && currentContent) {
          currentContent.innerHTML = newContent.innerHTML;
        }
      })
      .catch(e => console.log('🛒 Cart section refresh failed'));
    
    setTimeout(() => {
      fetch('/cart.js')
        .then(r => r.json())
        .then(cart => {
          document.querySelectorAll('[data-cart-count], .cart-count-bubble span').forEach(el => {
            el.textContent = cart.item_count;
          });
        });
    }, 500);
  }

  // Event: Toggle dropdown
  document.addEventListener('click', function(e) {
    const trigger = e.target.closest('[data-dropdown-trigger]');
    if (trigger) {
      e.preventDefault();
      const selector = trigger.closest('[data-variant-selector]');
      if (selector && !selector.classList.contains('is-loading')) {
        toggleDropdown(selector);
      }
      return;
    }
    
    // Select option
    const option = e.target.closest('.cart-variant-dropdown__option');
    if (option && !option.classList.contains('is-disabled')) {
      e.preventDefault();
      const selector = option.closest('[data-variant-selector]');
      const value = option.dataset.optionValue;
      
      if (selector && value) {
        // Update visual selection
        selector.querySelectorAll('.cart-variant-dropdown__option').forEach(opt => {
          opt.classList.remove('is-selected');
        });
        option.classList.add('is-selected');
        
        // Change variant
        changeVariant(selector, value);
      }
      return;
    }
    
    // Close dropdown when clicking outside
    if (!e.target.closest('.cart-item__variant-selector')) {
      closeAllDropdowns();
    }
  });

  // Close on Escape
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      closeAllDropdowns();
    }
  });

  console.log('🛒 Cart Variant Selector: Ready');
})();